import Component from './components/DocsUploader';

export default Component;
